<template>
  <b-container fluid>
    <b-row>
      <b-col xs="12" sm="12" md="6" lg="5">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{$t('main.esrdProtoCare.upload')}}</h4>
          </template>
          <template v-slot:body>
            <b-form-group>
              <b-row>
                <b-col cols="2" align-self="center">{{$t('main.general.age')}}:</b-col>
                <b-col cols="4"><b-form-input type="number" v-model="form.age"></b-form-input></b-col>
                <b-col cols="2" align-self="center">{{$t('main.general.height')}}:</b-col>
                <b-col cols="4"><b-form-input type="number" v-model="form.height"></b-form-input></b-col>
              </b-row>
              <b-row style="padding-top: 20px">
                <b-col>{{$t('main.general.gender')}}:</b-col>
                <b-col><b-form-radio v-model="form.gender" value=0>{{$t('main.general.male')}}</b-form-radio></b-col>
                <b-col><b-form-radio v-model="form.gender" value=1>{{$t('main.general.female')}}</b-form-radio></b-col>
              </b-row>
              <b-row style="padding-top: 20px">
                <b-col>{{$t('main.esrdProtoCare.diabetic')}}:</b-col>
                <b-col><b-form-radio v-model="form.diabetes" value=0>{{$t('main.esrdProtoCare.non-diabetic')}}</b-form-radio></b-col>
                <b-col><b-form-radio v-model="form.diabetes" value=1>{{$t('main.esrdProtoCare.diabetic')}}</b-form-radio></b-col>
              </b-row>
              <b-form-file
                class="upload-demo"
                accept=".csv"
                v-model="form.file"
                :browse-text="$t('main.esrdProtoCare.upload_browse')"
                :placeholder="$t('main.esrdProtoCare.upload_info')"
                :drop-placeholder="$t('main.esrdProtoCare.upload_drag')"
                style="margin-top: 20px"
              >
              </b-form-file>
            </b-form-group>
            <div>
              {{$t('main.esrdProtoCare.csv')}}
              <p class="state">{{$t('main.esrdProtoCare.statement')}}</p>
            </div>
            <b-row>
              <b-col>
                <b-button
                  variant="primary"
                  style="margin-bottom:15px"
                  @click="download"
                >{{$t('main.esrdProtoCare.sample')}}
                </b-button>
              </b-col>
              <b-col>
                <b-button
                  variant="primary"
                  @click="submitUpload"
                >{{$t('main.esrdProtoCare.analysis')}}
                </b-button>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
      <b-col :span="14">
        <iq-card v-if="rePatientChart">
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('main.general.indicators') }}</h4>
          </template>
          <template v-slot:headerAction>
            <div style="padding-right: 20px">
              <a @click="$store.commit('setSelectedGraph', [])">
                <span>{{ $t('main.general.clearSelected') }}</span>
              </a>
            </div>
          </template>
          <template v-slot:body>
            <div class="iq-card-body pl-0 pr-0 pb-0" v-show="patient_data_selector.length">
              <PatientDataSelector :item="patient_data_selector" :langType="getLocale()">
              </PatientDataSelector>
            </div>
          </template>
        </iq-card>
        <PatientDataChart v-if=" rePatientChart &&
              analyze !== undefined &&
              (selectedGraph.length >= 1 || analyze.predict !== undefined) "/>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <iq-card body-class="bg-primary rounded pt-2 pb-2 pr-2">
          <template v-slot:body>
            <div class="d-flex align-items-center justify-content-between">
              <h4 class="mb-0" style="font-size: 22px;margin-left: 10px;color: white;">
                {{ $t('main.esrdProtoCare.prototypeInformation') }}<i
                class="fa fa-id-card" style="margin-left: 5px;"></i>
              </h4>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-row v-if="rePatientChart">
      <b-col lg="7">
        <LineChart :order="prototypeOrder" width="600px"/>
      </b-col>
      <b-col lg="5">
        <iq-card class-name="iq-card-block iq-card-stretch">
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('main.esrdProtoCare.statistics') }}</h4>
          </template>
          <template v-slot:body>
            <div class="table-responsive" style="margin-left: 5px;">
              <table class="table mb-0 table-borderless">
                <thead>
                <tr>
                  <th scope="col" style="padding: 0.25rem; text-align: center">
                    {{ $t('main.esrdProtoCare.prototypeId') }}
                  </th>
                  <th scope="col" style="padding: 0.25rem; text-align: center">{{ $t('main.esrdProtoCare.age') }}</th>
                  <th scope="col" style="padding: 0.25rem; text-align: center">{{ $t('main.esrdProtoCare.gender') }}
                  </th>
                  <th scope="col" style="padding: 0.25rem; text-align: center">
                    {{ $t('main.esrdProtoCare.deathRate') }}
                  </th>
                  <th scope="col" style="padding: 0.25rem; text-align: center">{{ $t('main.esrdProtoCare.diabetes') }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="p in prototypeInfo" :key="p.id">
                  <td style="padding: 0.25rem; text-align: center">{{ p.id }}</td>
                  <td style="padding: 0.25rem; text-align: center">{{ p.age }}</td>
                  <td style="padding: 0.25rem; text-align: center">{{ p.gender.toFixed(1) }}%</td>
                  <td style="padding: 0.25rem; text-align: center">{{ p.mortality.toFixed(1) }}%</td>
                  <td style="padding: 0.25rem; text-align: center">{{ p.diabetes.toFixed(1) }}%</td>
                </tr>
                </tbody>
              </table>
            </div>
            <!--            <div style="margin-bottom: 100px;"></div>-->
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import Papa from 'papaparse'
import jschardet from 'jschardet'
import IqCard from '@/components/xray/cards/iq-card'
import { xray } from '@/config/pluginInit'
import APIHelper from '@/util/APIHelper'
import { deathReasonEn, medicalChar, medicalCharChinese, originMedicalChartEn } from '@/util/info'
import PPNPatientDataChart from '@/views/Charts/PPNPatientDataChart'
import PatientDataSelector from '@/views/Charts/PatientDataSelector'
import ColorHelper from '@/util/ColorHelper'
import PPNLineChart from '@/views/Charts/PPNLineChart'

export default {
  name: 'Prediction',
  // eslint-disable-next-line vue/no-unused-components
  components: {
    IqCard,
    PatientDataChart: PPNPatientDataChart,
    PatientDataSelector,
    LineChart: PPNLineChart
  },
  inject: ['reload'],
  data() {
    return {
      analyzeAdvice: undefined,
      file: null,
      top2: undefined,
      rePatientChart: false,
      adviceOnRiskThreshold: undefined,
      adviceOnRisk: undefined,
      urlAnalyzeApi: undefined,
      patient: undefined,
      display1: false,
      settings: undefined,
      getAnalyzeDataTimer: undefined,
      medicalCharChinese: medicalCharChinese,
      deathReasonEn,
      originMedicalChartEn,
      medicalChar: medicalChar,
      patient_data_selector: [],
      selector_item: ['cl', 'co2', 'wbc', 'hgb', 'urea', 'ca', 'k', 'na', 'cre', 'p', 'alb', 'crp', 'glu', 'weight', 'sys', 'dia'],
      prototypeInfo: [
        { id: 5, age: 74.95, gender: 78.3, mortality: 76.1, diabetes: 45.7 },
        { id: 4, age: 72.76, gender: 7.0, mortality: 56.3, diabetes: 41.4 },
        { id: 3, age: 63.71, gender: 96.2, mortality: 42.3, diabetes: 68.3 },
        { id: 2, age: 58.31, gender: 14.4, mortality: 35.1, diabetes: 33.3 },
        { id: 1, age: 44.03, gender: 94.7, mortality: 18.2, diabetes: 22.1 },
        { id: 0, age: 38.74, gender: 11.6, mortality: 9.5, diabetes: 9.8 }
      ],
      prototypeOrder: [3, 2, 0, 1, 5, 4],
      form: {
        age: 65,
        gender: 0,
        diabetes: 1,
        height: 173,
        file: undefined
      }
    }
  },
  created() {
    this.$store.commit('setShowValue', true)
    if (this.$store.state.ch) {
      this.$store.commit('setCh', new ColorHelper())
    }
    this.$store.commit('setSelectedGraph', [])
  },
  mounted() {
    xray.index()
  },
  computed: {
    lab() {
      return this.$store.state.lab
    },
    modifiedLab() {
      return this.$store.state.modifiedLab
    },
    selectedGraph() {
      return this.$store.state.selectedGraph
    },
    analyze() {
      return this.$store.state.analyze
    },
    analyzeData() {
      const { modifiedLab, patient } = this
      return {
        modifiedLab, patient
      }
    },
    ch() {
      return this.$store.state.ch
    }
  },
  methods: {
    download() {
      let downloadElement = document.createElement('a')
      downloadElement.href = '/prediction_example.csv'
      downloadElement.download = 'prediction_example.csv'
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
    },
    submitUpload() {
      let _self = this
      const fileReader = new FileReader()
      if (!this.form.file) {
        this.$Message.error({
          content: this.$t('main.general.uploadError')
        })
        return
      }
      let file = this.form.file
      fileReader.readAsDataURL(file)
      fileReader.onload = function (evt) {
        let str = atob(evt.target.result.split(';base64,')[1])
        // 要用二进制格式
        let encoding = jschardet.detect(str)
        encoding = encoding.encoding
        if (encoding === 'windows-1252') {
          // 有时会识别错误（如UTF8的中文二字）
          encoding = 'ANSI'
        }
        // 将csv转换成二维数组
        Papa.parse(file, {
          encoding,
          complete: res => {
            // UTF8 \r\n与\n混用时有可能会出问题
            let data = res.data
            if (JSON.stringify(data[data.length - 1]) === '[""]') {
              // 去除最后的空行
              data.pop()
            }
            let array = data
            var keys = array.shift()
            // objects.forEach(function (item) {
            //   item.amount = 3435.23
            // })
            let lab = array.map(function (values) {
              return keys.reduce(function (o, k, i) {
                o[k] = values[i]
                return o
              }, {})
            })
            _self.$store.commit('setLab', lab)
            _self.$store.commit('setModifiedLab', lab)
            _self.getAnalyzeData()
          }
        })
      }
    },

    getAnalyzeData() {
      clearTimeout(this.getAnalyzeDataTimer)
      this.getAnalyzeDataTimer = setTimeout(() => this.modifiedLab && APIHelper.getPPNAnalyze({
        patient: {
          'pdid': 'test'
        },
        static: {
          age: parseFloat(this.form.age),
          gender: parseInt(this.form.gender),
          height: parseFloat(this.form.height),
          diabetes: parseInt(this.form.diabetes)
        },
        lab: this.modifiedLab
      }).then(result => {
        this.rePatientChart = true
        this.$store.commit('setAnalyze', result)
        if (this.patient_data_selector.length === 0) {
          this.patient_data_selector = Object.keys(this.lab[0]).filter(item => item !== 'pdid' && item !== 'date')
        }
      }), 500)
    },

    getLocale() {
      return this.$i18n.locale === 'chi'
    }
  }
}
</script>

<style scoped>
</style>
